import { useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { FluxButton, FluxToolbar, FluxToolbarSpacer} from '@meltwater/flux-web-components-react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import JiraIntercom from './jiraintercom';
import styles from './jira.module.css';
import JiraSearch from './jiraSearch';
import CloudIcon from '@mui/icons-material/Cloud';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import logger from '../../utils/logger';

const JiraExternalLinks = ({ issuedata }) => {
    const [opID, setOpID] = useState(null);
    const [accountID, setAccountID] = useState(null);
    const [salesforceId, setSalesforceId] = useState(null);
    const [salesforceUrl, setSalesforceUrl] = useState(null);
    const [open, setOpen] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const [viewintercommess, setIntercommess] = useState('INTERCOM');
    
    // Function to extract Salesforce ID from opportunity URL
    const extractSalesforceId = (opportunityUrl) => {
        if (!opportunityUrl || opportunityUrl === 'NA' || opportunityUrl === 'N/A') {
            return null;
        }
        
        try {
            // Check if the URL contains salesforce or lightning
            if (opportunityUrl.toLowerCase().includes('salesforce') || opportunityUrl.toLowerCase().includes('lightning')) {
                const url = new URL(opportunityUrl);
                
                // Universal Lightning pattern: /lightning/r/{ObjectType}/{id}/
                const lightningMatch = url.pathname.match(/\/lightning\/r\/[^/]+\/([a-zA-Z0-9]{15,18})/);
                if (lightningMatch) {
                    return lightningMatch[1];
                }
                
                // Fallback: Look for any 15-18 character ID in the path
                const pathSegments = url.pathname.split('/').filter(segment => segment.length > 0);
                for (const segment of pathSegments) {
                    if (segment.length >= 15 && segment.length <= 18 && /^[a-zA-Z0-9]+$/.test(segment)) {
                        return segment;
                    }
                }
                
                // Final fallback: id parameter
                const idParam = url.searchParams.get('id');
                if (idParam && idParam.length >= 15 && idParam.length <= 18) {
                    return idParam;
                }
            }
        } catch (error) {
            logger.debug('Error extracting Salesforce ID', { 
                opportunityUrl, 
                error: error.message 
            });
        }
        
        return null;
    };
    
    useEffect(() => {
        
        if (issuedata && issuedata.intercom.length === 0) {
            setIntercommess("Intercom chat not yet available")
        }
        else {
            setIntercommess("Open intercom chat")
        }

        if (issuedata) {
            setOpID(issuedata.opportunityID)
            setAccountID(issuedata.accountID)
            
            // Extract Salesforce ID if available
            const sfId = extractSalesforceId(issuedata.opportunity);
            if (sfId) {
                setSalesforceId(sfId);
                setSalesforceUrl(issuedata.opportunity);
            } else {
                setSalesforceId(null);
                setSalesforceUrl(null);
            }
        }
        else {
            setIntercommess("Open intercom chat")
        }
    }, [issuedata]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    function intercomdialog() {
        return (<>

            <Tooltip title={viewintercommess} arrow>

                <FluxButton disabled={!issuedata.intercom.length>0} tint="primary" onClick={handleClickOpen('paper')}>Intercom</FluxButton>

            </Tooltip>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            // className={styles.dialogTitle}
            >
                <DialogTitle>Intercom Chat</DialogTitle>
                <div style={{ maxHeight: '60%', overflowY: 'auto' }}>
                    <JiraIntercom intercom={issuedata.intercom}></JiraIntercom>
                </div>
                <DialogActions>
                    <FluxButton dense tint="primary" type="filled" onClick={handleClose}>OK</FluxButton>
                </DialogActions>
            </Dialog>
        </>)
    }
    const IntercomDialog = intercomdialog;
    return (
        <div className={styles.Jira}>
        <div className={styles.tools} >
          
          
        {/* <Badge badgeContent={issuedata.intercom.length>0 ? "Intercom" : 0}color='success' > */}
        
                    <FluxToolbar >
                  
                      
                  
                    
                        {opID > 0 &&
                        <>
                        <Tooltip title={"View all tickets for this Account"} arrow>
                            <FluxButton tint="primary" href={`relatedtickets/${opID}/OpportunityID`}>Opportunity Tickets</FluxButton>
                            </Tooltip>
                            </>

                        }
                        {accountID > 0 &&
                        <>  <Tooltip title={"View all tickets for this Account"} arrow>
                            <FluxButton tint="primary" href={`relatedtickets/${accountID}/AccountID`}>Account Tickets</FluxButton>
                            </Tooltip>
                            
                            </>
                        }
                    
                   
                        <IntercomDialog></IntercomDialog>
                        
                        {/* View All Tickets Button - shows when Account ID or Salesforce ID is available */}
                        {(accountID > 0 || salesforceId) && (
                            <Tooltip title={`View all tickets for this ${salesforceId ? 'Salesforce opportunity' : 'account'}`} arrow>
                                <FluxButton 
                                    tint="primary" 
                                    href={salesforceId ? `salesforce/${salesforceId}?company=${encodeURIComponent(issuedata.companyname || '')}` : `relatedtickets/${accountID}/AccountID`}
                                    startIcon={<ConfirmationNumberIcon />}
                                >
                                    View All Tickets
                                </FluxButton>
                            </Tooltip>
                        )}
                        
                        {/* Salesforce Button */}
                        {salesforceId && (
                            <Tooltip title={`Go to Salesforce: (Saleforce Account Required)`} arrow>
                                <FluxButton 
                                    tint="primary" 
                                    target="_blank" 
                                    href={salesforceUrl}
                                    startIcon={<CloudIcon />}
                                >
                                    Salesforce
                                </FluxButton>
                            </Tooltip>
                        )}
                        
                        <Tooltip title={"Service Desk Portal"} arrow>
                            <FluxButton tint="primary" target="_blank" href={`https://meltwater.atlassian.net/servicedesk/customer/portal/43/${issuedata.issue}`}>View Portal</FluxButton>
                        </Tooltip>
                        <Tooltip title={"Jira Portal (Jira Account Required)"} arrow>
                    <FluxButton tint="primary" target="_blank" href={`https://meltwater.atlassian.net/browse/${issuedata.issue}`}>View Jira</FluxButton>
                    </Tooltip>
                   <FluxToolbarSpacer size='flex'></FluxToolbarSpacer>
                    <JiraSearch  /> 
                       
                    </FluxToolbar>
                    {/* </Badge> */}
     </div>
        </div>
    );
};

export default JiraExternalLinks;